import { Constants } from './constants';
import { DataMap } from './dataMapping';
function dataValuesSubCategoryToMap(dataValues) {
    const dataMapArray = [];
    Object.keys(dataValues.SubCategoryDataMapping).forEach((dataValueKey)=>{
        const subDataValues = dataValues.SubCategoryDataMapping[`${dataValueKey}`];
        if (!subDataValues.IsReference) {
            dataMapArray.push(subDataValues);
        }
    });
    return dataMapArray;
}
function dataCollectionToMap(dataCollection) {
    const dataMapArray = [];
    Object.keys(dataCollection).forEach((categoryKey)=>{
        const dataValues = dataCollection[`${categoryKey}`];
        if (!dataValues.IsReference) {
            dataMapArray.push(dataValues);
        }
        if (dataValues.SubCategoryDataMapping) {
            dataMapArray.push(...dataValuesSubCategoryToMap(dataValues));
        }
    });
    return dataMapArray;
}
export function dataMapToArray(dataMap) {
    const dataMapArray = [];
    Object.keys(dataMap).forEach((dataCollectionKey)=>{
        if (dataCollectionKey === Constants.DataMapCollectionKeys.categories) {
            Object.keys(dataMap.categories).forEach((categoryDataKey)=>{
                const categoryDataMap = dataCollectionToMap(dataMap.categories[`${categoryDataKey}`]);
                dataMapArray.push(...categoryDataMap);
            });
        } else {
            const dataCollectionMap = dataCollectionToMap(dataMap[`${dataCollectionKey}`]);
            dataMapArray.push(...dataCollectionMap);
        }
    });
    return dataMapArray;
}
function getDataCollectionDataValuesFromUrlKey(dataCollection, curatedUrlValue) {
    let dataValues;
    Object.keys(dataCollection).forEach((dataKey)=>{
        if (dataCollection[`${dataKey}`].UrlKey === curatedUrlValue) {
            dataValues = dataCollection[`${dataKey}`];
        }
    });
    return dataValues;
}
export function getDataValuesFromUrlKey(curatedUrlKey, curatedUrlValue) {
    const dataCollectionKey = Constants.CuratedQueryParamsToDataMapCollectionKeyMap[`${curatedUrlKey}`];
    if (!DataMap[`${dataCollectionKey}`]) {
        return null;
    }
    let dataValues;
    if (dataCollectionKey === Constants.DataMapCollectionKeys.categories) {
        Object.keys(DataMap.categories).forEach((categoryDataKey)=>{
            if (!dataValues) {
                dataValues = getDataCollectionDataValuesFromUrlKey(DataMap.categories[`${categoryDataKey}`], curatedUrlValue);
            }
        });
    } else {
        dataValues = getDataCollectionDataValuesFromUrlKey(DataMap[`${dataCollectionKey}`], curatedUrlValue);
    }
    return dataValues;
}
export function isRequiredPricings() {
    return false;
}
